import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DataTable from "react-data-table-component";
import { Triangle } from "react-loader-spinner";
import { Link } from "react-router-dom";
import WaiterForm from "../component/WaiterForm";
import WaiterService from "../../../services/OrderingServices/WaiterService";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import toast from "react-hot-toast";
import DeleteModal from "../../../Components/Common/DeleteModal";

const Waiter = () => {
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [waiterList, setWaiterList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const toggleModal = (row) => {
  //   setSelectedItem(row);
  //   setIsModalOpen(!isModalOpen);
  // };
  const [deleteModal, setDeleteModal] = useState(false);

  const toggleModal = (item = null) => {
    if (!isModalOpen && item) {
      setSelectedItem(item); // for editing
    } else {
      setSelectedItem(null); // reset to create mode
    }
    setIsModalOpen(!isModalOpen);
  };

  const customStyles = {
    headCells: { style: { fontSize: "0.92rem", fontWeight: 610 } },
    rows: { style: { fontSize: "0.9rem" } },
  };
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },

    {
      name: `Name`,
      selector: (row) => `${row.firstName} ${row.lastName}`,
      sortable: true,
    },
    {
      name: `Email`,
      selector: (row) => <span title={row.email}>{row.email}</span>,
      sortable: true,
    },
    {
      name: `Phone no`,
      selector: (row) => row.phoneNumber,
      sortable: true,
    },
    {
      name: `Role`,
      selector: (row) => row.roles[0],
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => toggleModal(row)} // ✅ Correct
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await WaiterService.getList();

      setWaiterList(response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchData();
  }, []);

  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = waiterList.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);
    const searchContext = `${pkg?.firstName || ""} ${pkg?.lastName || ""} ${
      pkg?.email || ""
    } ${pkg?.phoneNumber || ""}`.toLowerCase();
    const matchesFilter = searchContext.includes(filterText.toLowerCase());
    return matchesFilter;
  });

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedItem) {
      try {
        const response = await WaiterService.delete(selectedItem);
        setWaiterList((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedItem)
        );
        toast.success(response);
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedItem(null);
      }
    }
  };
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Staff List" pageTitle="Staff management" />

        <Row>
          <Col md={8} xs={12} className="mb-2">
            <InputGroup>
              <Input
                placeholder="Search by name, email and phone number"
                value={filterText}
                onChange={handleFilterChange}
              />
            </InputGroup>
          </Col>
          <Col
            md={4}
            xs={12}
            className="d-flex justify-content-end align-items-end mb-2"
          >
            <button
              className="btn btn-success px-1 px-sm-2"
              onClick={() => toggleModal(null)}
            >
              + Add Staff
            </button>
          </Col>
        </Row>
        <div className="d-none d-lg-block d-md-block">
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData}
          />
        </div>
        {loading ? (
          <div className="my-5 d-flex justify-content-center">
            <Triangle
              visible={true}
              height="60"
              width="60"
              color="#5B71B9"
              ariaLabel="triangle-loading"
            />
          </div>
        ) : (
          <>
            {filteredData?.map((item, index) => (
              <Card
                key={item.id || index}
                className="mt-2  d-block d-lg-none"
              >
                <CardBody>
                  <Row>
                    <Col xs={10}>
                      <h6 className="mb-2">{`${item.firstName} ${item.lastName}`}</h6>
                      <h6 className="mb-2 text-muted">{item?.email}</h6>
                      <h6 className="mb-2">{item?.phoneNumber}</h6>
                      <h6 className="">
                        <strong>Role:</strong> {item?.roles[0] || "none"}
                      </h6>
                    </Col>
                    <Col xs={2}>
                      <div>
                        <Dropdown
                          isOpen={item.dropdownOpen || false}
                          toggle={() => {
                            setWaiterList((prev) =>
                              prev.map(
                                (customer) =>
                                  customer.id === item.id
                                    ? {
                                        ...customer,
                                        dropdownOpen: !customer.dropdownOpen,
                                      }
                                    : { ...customer, dropdownOpen: false } // close all others
                              )
                            );
                          }}
                          direction="down"
                        >
                          <DropdownToggle
                            color="primary"
                            outline
                            className="btn-sm  shadow-sm rounded-circle"
                          >
                            <i className="ri-more-2-fill"></i>
                          </DropdownToggle>
                          <DropdownMenu end>
                            <DropdownItem
                              onClick={() => toggleModal(item)} // ✅ Correct
                            >
                              <i className="ri-edit-line text-warning me-2"></i>{" "}
                              Edit
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => handleDeleteClick(item?.id)}
                            >
                              <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                              Delete
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))}
          </>
        )}
      </div>

      <WaiterForm
        isOpen={isModalOpen}
        toggle={toggleModal}
        selectedItem={selectedItem}
        fetchData={fetchData}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedItem} // Pass the selected item
      />
    </Container>
  );
};

export default Waiter;
